import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import * as GameActions from '../redux/actions/game_actions';

const useStyles = makeStyles((theme) => ({
  button: {
    width: '100%',
  },
  padding: {
    padding: theme.spacing(0, 1),
  },
}));

export default function LetterTile({index}) {
  const classes = useStyles();
  const letterVal = useSelector((state) => state.game.boxes[index]);
  const dispatch = useDispatch();

  const onTake = (index) => {
    dispatch(GameActions.takeLetter(index));
  };

  return (
    <Button className={classes.button} disabled={letterVal.val.val === ''} variant="contained" onClick={() => onTake(letterVal.index)}>
      <Box pt={1} pb={1}>
        <Badge badgeContent={letterVal.val.score} color="primary" anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
          <Typography className={classes.padding} variant="h5">
            {letterVal.val.val}
          </Typography>
        </Badge>
      </Box>
    </Button>
  );
};
